import React from 'react';
import PropTypes from 'prop-types';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';

/**
 * Wrapper for MUI ToggleButtonGroup with toggle buttons.
 * Pure UI: all state is controlled by the parent.
 */
const AppToggleButtonGroupComponent = ({
  value,
  onChange,
  options = [],
  exclusive = true,
  size = 'medium',
  color = 'primary',
  ...props
}) => {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive={exclusive}
      onChange={(event, newValue) => {
        if (onChange) {
          onChange(event, newValue);
        }
      }}
      size={size}
      color={color}
      {...props}
    >
      {options.map(({ label, value: optionValue, disabled = false }) => (
        <ToggleButton key={optionValue} value={optionValue} disabled={disabled}>
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

AppToggleButtonGroupComponent.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      disabled: PropTypes.bool,
    })
  ),
  exclusive: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  color: PropTypes.oneOf(['primary', 'secondary', 'error', 'warning', 'info', 'success']),
};

export default AppToggleButtonGroupComponent;


